import type { ShortBook } from 'library/types';

const getNormalizedBookTitle = (book: ShortBook): string | null => {
  const title: unknown = book.title;
  if (typeof title !== 'string') return null;

  const normalizedTitle = title.trim();
  return normalizedTitle || null;
};

export const prepareActivityMonitoringBooks = (books: readonly ShortBook[]): ShortBook[] => {
  const validBooks = books.reduce<ShortBook[]>((result, book) => {
    const title = getNormalizedBookTitle(book);
    if (title) result.push({ ...book, title });

    return result;
  }, []);

  return validBooks.sort((a, b) => a.title.localeCompare(b.title));
};

export const buildActivityMonitoringBookTitleMap = (books: readonly ShortBook[]): Map<number, string> =>
  new Map(prepareActivityMonitoringBooks(books).map((book) => [book.id, book.title]));
